
import { defineComponent } from "vue";

export default defineComponent({
  name: "privacy",
  components: {},
});
